// @flow
import React, { Component } from 'react';
import changeWindowLocation from 'app/common/lib/util/changeWindowLocation';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import storage from 'app/common/lib/Storage';
import templateConst from 'app/common/lib/templateConst';
import user from 'app/common/lib/User';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { track } from 'app/common/lib/react/analytics';
import { trackRegisterActionWithAuxData } from 'app/common/lib/util/trackRegisterAction';
import { Box, Button, Text } from 'gestalt';

type Props = {};

const partnerAccountConvertUrl = templateConst.settings.PARTNER_CONVERT_ACCOUNT;
const partnerAccountCreateUrl = templateConst.settings.PARTNER_SITE_SIGNUP;

export default class BusinessAccountCreateWarningModal extends Component<Props> {
  componentDidMount() {
    track(PCONST.thrift.EventType.RENDER, {
      component: PCONST.thrift.ComponentType.PARTNER_CONVERT_INTERSTITIAL,
    });
  }

  handleLogoutAndCreateClick = (evt: SyntheticEvent<>) => {
    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.PARTNER_CONVERT_INTERSTITIAL,
      element: PCONST.thrift.ElementType.PARTNER_CONVERT_INTERSTITIAL_LOGOUT,
    });
    this.logout(evt);
  };

  logout = (evt: SyntheticEvent<>) => {
    evt.preventDefault();
    evt.stopPropagation();
    ResourceFactory.create('UserSessionResource', { disable_auth_failure_redirect: true })
      .callDelete()
      .then(() => {
        trackRegisterActionWithAuxData('logout', {
          tags: { app: 'web_denzel', reason: 'user_initiated' },
        });
        storage.sessionStorage.clear();
        storage.localStorage.clear();

        user.logout().then(() => {
          changeWindowLocation(partnerAccountCreateUrl);
        });
      });
  };

  render() {
    return (
      <Modal
        accessibilityCloseLabel={i18n._('close', 'Accessible label for the modal close button')}
        heading={i18n._('Get a business account', 'Heading for warning modal')}
        onDismiss={() => {}}
        size="md"
        footer={
          <Box display="flex" justifyContent="end">
            <Box deprecatedPadding={{ x: 1 }}>
              <Button
                onClick={() => {
                  track(PCONST.thrift.EventType.CLICK, {
                    component: PCONST.thrift.ComponentType.PARTNER_CONVERT_INTERSTITIAL,
                    element: PCONST.thrift.ElementType.PARTNER_CONVERT_INTERSTITIAL_CANCEL,
                  });
                  changeWindowLocation('/');
                }}
                text={i18n._('Not now', 'Cancel button text')}
                inline
                size="md"
              />
            </Box>
            <Box>
              <Button
                color="red"
                onClick={() => {
                  track(PCONST.thrift.EventType.CLICK, {
                    component: PCONST.thrift.ComponentType.PARTNER_CONVERT_INTERSTITIAL,
                    element: PCONST.thrift.ElementType.PARTNER_CONVERT_INTERSTITIAL_CONVERT,
                  });
                  changeWindowLocation(partnerAccountConvertUrl);
                }}
                text={i18n._(
                  'Switch to a business',
                  'link text to go to the url to convert to a business account',
                )}
                inline
                size="md"
              />
            </Box>
          </Box>
        }
        accessibilityModalLabel={i18n._(
          'Create a new business account',
          'Label for a modal to create a business account',
        )}
        role="alertdialog"
      >
        <Box deprecatedPadding={3}>
          <Text smSize="xs" mdSize="sm" lgSize="md">
            {interpolateNamedTemplate(
              i18n._(
                'You can switch to a business account or log out and {{ convertAccountLink }}',
              ),
              {
                convertAccountLink: (
                  <a href="" key="logout" role="button" onClick={this.handleLogoutAndCreateClick}>
                    {i18n._(
                      'create a new business account',
                      'link text to logout and create a business account',
                    )}
                  </a>
                ),
              },
            )}
          </Text>
        </Box>
      </Modal>
    );
  }
}
